export default __webpack_public_path__ + "static/media/bg.74566a46.png";